import { styled } from '@/stitches.config';

import { Box, Form, FormField } from '@base-app';

export const StyledForm = styled(Form, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledFormField = styled(FormField, {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$4',
  width: '275px',
});

export const StyledCustomContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$6',
  textAlign: 'initial',
});

export const StyledButtonContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  marginTop: '$2',
});

export const StyledFormContainer = styled(Box, {
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
});
